import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPixelPageView } from "@/lib/meta-pixel";

/**
 * Fires a Meta Pixel PageView on every client-side route change.
 *
 * The initial hard load's PageView is already fired by initMetaPixel() (the
 * consent-gated loader in src/lib/meta-pixel.ts) — the pixel no longer lives in
 * index.html. We skip the first render here to avoid a double-count on entry.
 * After that, this SPA navigates without full page loads, so each pathname
 * change needs its own PageView for Meta to see the page-by-page funnel.
 *
 * Mount ONCE at the App level, above <Routes/>. We key on pathname only —
 * query-string changes (filters, oauth tokens) shouldn't fire a new PageView.
 */
export function MetaPixelRouteTracker() {
  const { pathname } = useLocation();
  const isFirstRef = useRef(true);

  useEffect(() => {
    if (isFirstRef.current) {
      isFirstRef.current = false;
      return;
    }
    trackPixelPageView();
  }, [pathname]);

  return null;
}
